import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-f5c57928.js';
import React__default, { useState, useEffect, cloneElement } from 'react';
import PropTypes from 'prop-types';

function Map(_ref) {
  var locations = _ref.locations,
    children = _ref.children,
    containerStyle = _ref.containerStyle,
    MapInstance = _ref.mapProvider,
    labels = _ref.labels,
    i18n = _ref.i18n;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    markers = _useState2[0],
    setMarkers = _useState2[1];
  useEffect(function () {
    if (locations) {
      setMarkers({
        locations: locations
      });
    }
    return function () {
      setMarkers(null);
    };
  }, [locations]);
  return markers && /*#__PURE__*/React__default.createElement(MapInstance, {
    markers: markers.locations,
    popupLoadingText: labels === null || labels === void 0 ? void 0 : labels.loading,
    fromChina: (i18n === null || i18n === void 0 ? void 0 : i18n.locale) === 'CN',
    i18n: i18n,
    containerStyle: containerStyle
  }, children ? cloneElement(children, {
    labels: labels
  }) : null);
}
Map.defaultProps = {
  locations: null,
  children: null,
  i18n: null,
  containerStyle: {
    width: '100%',
    height: '330px'
  }
};
Map.propTypes = {
  labels: PropTypes.shape().isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({})),
  children: PropTypes.node,
  i18n: PropTypes.shape({
    messages: PropTypes.shape({}),
    locale: PropTypes.string,
    IntlProvider: PropTypes.func
  }),
  mapProvider: PropTypes.elementType.isRequired,
  containerStyle: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string
  })
};

/* eslint-disable import/no-cycle */
var SimpleMapView = {};
SimpleMapView.Full = Map;
SimpleMapView.Full.displayName = 'SimpleMapFull';

export default SimpleMapView;
